var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from "../../../hooks/useAuth";
import { Toast } from "../../elements/Toast";
import { Text } from "../../elements/Text";
export function LastTryToast() {
    var _a = useAuth(), isRetriesLeft = _a.isRetriesLeft, onDimissRetriesLeftToast = _a.onDimissRetriesLeftToast;
    return (_jsx(Toast, { open: isRetriesLeft, onDimiss: onDimissRetriesLeftToast, message: _jsxs(Text, __assign({ textStyle: "body1", color: "white" }, { children: ["Esta \u00E9 sua \u00FAltima tentativa, se estiver com", _jsx("br", {}), "problemas para entrar, tente", " ", _jsx(Text, __assign({ href: "/senha/email", textStyle: "body1link", color: "white", renderAs: "a" }, { children: "recuperar sua senha." }))] })) }));
}
